/* eslint-disable react/jsx-no-target-blank */

import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  useColorModeValue,
  Tooltip,
} from "@chakra-ui/react";
import { MdPhone, MdEmail, MdLocationOn, MdOutlineEmail } from "react-icons/md";
import { FiPhoneCall } from "react-icons/fi";

import { BsPerson } from "react-icons/bs";

import { AiFillGithub } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";

import { useToast } from "@chakra-ui/react";
import emailjs from "emailjs-com";

import { useFormik } from "formik";
import { ContactSchema } from "./schemas/ContactSchema";

//
const Contact = () => {
  const toast = useToast();

  const initialValues = {
    Name: "",
    EmailS: "",
    Message: "",
    Mobile: "",
  };

  const SendMail = (templateParams) => {
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
        },
        (err) => {
          console.log("FAILED...", err);
        }
      );

    toast({
      title: "Message sent successfully.",
      description: "to Sufiyan.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues,
    validationSchema: ContactSchema,
    onSubmit: (values, action) => {
      action.resetForm();
      setValues(initialValues);
      SendMail({
        name: values.Name,
        "user-email": values.EmailS,
        message: values.Message,
        Mobile: values.Mobile,
      });
    },
  });

  const bg = useColorModeValue(
    "#ebf8ff",
    "linear-gradient(221deg, rgba(14,4,4,1) 0%, rgba(61,61,61,1) 51%, rgba(64,64,64,1) 60%, rgba(55,55,55,1) 70%, rgba(14,4,4,1) 100%)"
  );
  const bgN = useColorModeValue(
    "#e74d4d",
    "linear-gradient(221deg, rgba(14,4,4,1) 0%, rgba(61,61,61,1) 51%, rgba(64,64,64,1) 60%, rgba(55,55,55,1) 70%, rgba(14,4,4,1) 100%)"
  );
  const contatColor = useColorModeValue("white", "#eac288");
  const buttonColor = useColorModeValue(
    "#e53e3e",
    "linear(to-b, #ffdda1, #b07844)"
  );
  const onHoverColor = useColorModeValue("#af0e0e", "#835d3b");

  return (
    <Container
      p={{ base: "0", sm: "none" }}
      marginBottom={{ base: "70px", md: "0px" }}
      id="contact"
      bg={bg}
      maxW="full"
      mt={0}
      centerContent
      overflow="hidden"
    >
      <Flex>
        <Box
          w={{ base: "full", lg: "fit-content" }}
          boxShadow="rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;"
          bg={bgN}
          color="white"
          borderRadius="lg"
          m={{ sm: 4, md: 16, lg: 10 }}
          p={{ sm: 5, md: 5, lg: 16 }}
        >
          <Box p={{ base: "5", sm: "10" }}>
            <Wrap
              w={{ base: "full", lg: "fit-content" }}
              spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}
            >
              <WrapItem>
                <Box>
                  <Heading color={contatColor}>Contact</Heading>
                  <Text mt={{ sm: 3, md: 3, lg: 5 }} color="white">
                    Fill up the form below to contact
                  </Text>
                  <Box py={{ base: 5, sm: 5, md: 0, lg: 10 }}>
                    <VStack
                      direction={{ base: "row", md: "row", lg: "columns" }}
                      pl={0}
                      spacing={3}
                      alignItems="flex-start"
                    >
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        fontWeight="medium"
                        _hover={{ border: "2px solid white" }}
                        leftIcon={<MdPhone size="20px" />}
                      >
                        +91-7770055910
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        fontWeight="medium"
                        _hover={{ border: "2px solid white" }}
                        leftIcon={<MdEmail size="20px" />}
                      >
                        sufiyan.shaikh.developer@gmail.com
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        fontWeight="medium"
                        _hover={{ border: "2px solid white" }}
                        leftIcon={<MdLocationOn size="20px" />}
                      >
                        Maharashtra, India
                      </Button>
                    </VStack>
                  </Box>
                  <HStack
                    mt={{ md: 3, lg: 10 }}
                    spacing={5}
                    px={5}
                    alignItems="flex-start"
                  >
                    <a href="https://github.com/suFi7867" target="_blank">
                      <IconButton
                        _hover={{ fontSize: "5xl" }}
                        bgGradient={buttonColor}
                        size="md"
                        fontSize="4xl"
                        colorScheme="red"
                        variant="solid"
                        icon={<AiFillGithub />}
                      />
                    </a>

                    <a
                      href="https://www.linkedin.com/in/sufiyan-shaikh-developer"
                      target="_blank"
                    >
                      <IconButton
                        size="md"
                        fontSize="3xl"
                        colorScheme="red"
                        variant="solid"
                        _hover={{ fontSize: "5xl" }}
                        bgGradient={buttonColor}
                        icon={<BsLinkedin />}
                      />
                    </a>
                  </HStack>
                </Box>
              </WrapItem>
              <WrapItem w={{ base: "full", lg: "fit-content" }}>
                <Box
                  w={{ base: "full", lg: "fit-content" }}
                  bg="white"
                  borderRadius="lg"
                >
                  <Box m={{ base: 6, md: 8 }} color="#0B0E3F">
                    <VStack spacing={5}>
                      <FormControl id="name">
                        <FormLabel>Your Name</FormLabel>
                        <Tooltip
                          label={
                            errors.Name && touched.Name ? errors.Name : null
                          }
                          bgColor={"red.500"}
                          placement="top"
                          hasArrow
                          arrowSize={5}
                        >
                          <InputGroup>
                            <InputLeftElement
                              pointerEvents="none"
                              children={<BsPerson color="gray.800" />}
                            />

                            <Input
                              name="Name"
                              value={values.Name}
                              borderColor={
                                errors.Name && touched.Name ? "red" : "gray"
                              }
                              borderWidth={
                                errors.Name && touched.Name ? "2px" : "1px"
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              type="text"
                              size="md"
                            />

                            {/* errors.Name && touched.Name ? (<Text color={"red"} bottom={"-1.5rem"} position={"absolute"}> {errors.Name} </Text> ) : null */}
                          </InputGroup>
                        </Tooltip>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Mail</FormLabel>
                        <Tooltip
                          label={
                            errors.EmailS && touched.EmailS
                              ? errors.EmailS
                              : null
                          }
                          bgColor={"red.500"}
                          placement="top"
                          hasArrow
                          arrowSize={5}
                        >
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={<MdOutlineEmail color="gray.800" />}
                            />
                            <Input
                              name="EmailS"
                              value={values.EmailS}
                              borderColor={
                                errors.EmailS && touched.EmailS ? "red" : "gray"
                              }
                              borderWidth={
                                errors.EmailS && touched.EmailS ? "2px" : "1px"
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              type="text"
                              size="md"
                            />
                          </InputGroup>
                        </Tooltip>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Mobile</FormLabel>
                        <Tooltip
                          label={
                            errors.Mobile && touched.Mobile
                              ? errors.Mobile
                              : null
                          }
                          bgColor={"red.500"}
                          placement="top"
                          hasArrow
                          arrowSize={5}
                        >
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={<FiPhoneCall color="gray.800" />}
                            />
                            <Input
                              name="Mobile"
                              value={values.Mobile}
                              type="number"
                              borderColor={
                                errors.Mobile && touched.Mobile ? "red" : "gray"
                              }
                              borderWidth={
                                errors.Mobile && touched.Mobile ? "2px" : "1px"
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              size="md"
                            />
                          </InputGroup>
                        </Tooltip>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Message</FormLabel>
                        <Tooltip
                          label={
                            errors.Message && touched.Message
                              ? errors.Message
                              : null
                          }
                          bgColor={"red.500"}
                          placement="top"
                          hasArrow
                          arrowSize={5}
                        >
                          <Textarea
                            name="Message"
                            value={values.Message}
                            borderColor={
                              errors.Message && touched.Message ? "red" : "gray"
                            }
                            borderWidth={
                              errors.Message && touched.Message ? "2px" : "1px"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            _hover={{
                              borderRadius: "gray.300",
                            }}
                            placeholder="message"
                          />
                        </Tooltip>
                      </FormControl>
                      <FormControl id="name" float="right">
                        <Button
                          _hover={{ bg: onHoverColor }}
                          bgGradient={buttonColor}
                          onClick={handleSubmit}
                          variant="solid"
                          fontWeight="medium"
                          color="white"
                          colorScheme="red"
                        >
                          Send Message
                        </Button>
                      </FormControl>
                    </VStack>
                  </Box>
                </Box>
              </WrapItem>
            </Wrap>
          </Box>
        </Box>
      </Flex>
      <Text fontSize={{ base: "sm", md: "18px" }}>
        © 2020 Designed and Built by Sufiyan Shaikh
      </Text>
    </Container>
  );
};

export default Contact;
